var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { staticClass: "controls" },
    [
      _c(
        "w-button-bar",
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.previous-period", {
                    period: _vm.$ct("view-type-" + _vm.state.currentViewType),
                  }),
                  expression:
                    "$ct('tooltip.previous-period', {period:$ct('view-type-' + state.currentViewType)})",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.state.calendarPrev()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "chevron-left" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.next-period", {
                    period: _vm.$ct("view-type-" + _vm.state.currentViewType),
                  }),
                  expression:
                    "$ct('tooltip.next-period', {period:$ct('view-type-' + state.currentViewType)})",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.state.calendarNext()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "chevron-right" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.go-to-today", {
                    period: _vm.$ct("view-type-" + _vm.state.currentViewType),
                  }),
                  expression:
                    "$ct('tooltip.go-to-today', {period:$ct('view-type-' + state.currentViewType)})",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.state.calendarGoToToday()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "calendar-day" } })],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title-month" }, [
        _c("span", [
          _vm._v(" " + _vm._s(_vm.$t(_vm.state.getTitleKey())) + " "),
          _vm.weekNumber
            ? _c("span", { staticClass: "week-number" }, [
                _vm._v(
                  _vm._s(
                    _vm.$ct("week-number", {
                      week: _vm.weekNumber,
                      year: _vm.state.getWeekYear(),
                    })
                  )
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("w-spacer"),
      _c(
        "w-button-bar",
        { staticClass: "mr" },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("per-calendar"),
                  expression: "$ct('per-calendar')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.state.setViewTypePerCalendar()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "calendar" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-button-bar",
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.day-display"),
                  expression: "$ct('tooltip.day-display')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.state.setViewTypeDay()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "calendar-day" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.week-display"),
                  expression: "$ct('tooltip.week-display')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.state.setViewTypeWeek()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "calendar-week" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.month-display"),
                  expression: "$ct('tooltip.month-display')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.state.setViewTypeMonth()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "calendar-alt" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }